export enum TwtOrderType {
  FOR_SALE_LISTING = 'for_sale_listing',
  LONG_TERM_RENTAL = 'long_term_rental',
  SHORT_TERM_RENTAL = 'short_term_rental',
  COMMERCIAL = 'commercial',
}
